import React, { useContext, useState } from "react";
import "./Details.css";
import { Context } from "../../../context/Context";
import { useAccess } from "../../../access/hooks/useAccess";
import { translations } from "../../../utils/lang";
import { Button, Input, Select , InlineLink} from "../../ui";

const fieldLabels = [
  "organization",
  "commercialNumber",
  "taxNumber",
  "ownerName",
  "ownerPhone",
  "ownerEmail",
  "type",
  "subscriptionType",
  "infoUrl",
  "contractsUrl",
  "taxInvoicesUrl",
];

const mainFieldLabels = [
  "businessName",
  "branchNumber",
  "name",
  "phone",
  "city",
  "email",
];

const subscriptionOptions = ["L", "U", "D"];

export const RestaurantDetails = ({
  data,
  onSave,
  mainData,
  onSaveMain,
  restaurantId,
}) => {
  const { lang } = useContext(Context);
  const { can } = useAccess();
  const [isEditing, setIsEditing] = useState(false);
  const [form, setForm] = useState(data || {});
  const [mainForm, setMainForm] = useState(mainData || {});

  const getSubscriptionLabel = (key) =>
    translations[lang].restaurants.restaurantsRow.subscriptionTypes[key] || key;

  function isObjectEqualCaseSensitive(obj1, obj2) {
    const keys1 = Object.keys(obj1 || {});
    const keys2 = Object.keys(obj2 || {});

    if (keys1.length !== keys2.length) return false;

    for (let key of keys1) {
      if (!obj2.hasOwnProperty(key)) return false;
      if (obj1[key] !== obj2[key]) return false;
    }

    return true;
  }

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleMainDataChanges = (field, value) => {
    setMainForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = () => {
    if (!can("restaurant.details.update", { restaurantId })) return;
    if (!isObjectEqualCaseSensitive(mainForm, mainData)) {
      onSaveMain(mainForm);
    }

    if (!isObjectEqualCaseSensitive(form, data)) {
      onSave(form);
    }

    setIsEditing(false);
  };

  const handleCancel = () => {
    setForm(data);
    setMainForm(mainData);
    setIsEditing(false);
  };

  return (
    <>
      <div className="details-grid">
        {fieldLabels.map((key) => {
          const isUrl = key.endsWith("Url");

          return (
            <div className="detail-row" key={key}>
              <strong>
                {
                  translations[lang].restaurants.restaurantsRow.details
                    .fieldLabels[key]
                }
                :
              </strong>

              {isEditing ? (
                key === "subscriptionType" ? (
                  <Select
                    placeholder={
                      translations[lang].restaurants.selectSubscription
                    }
                    options={subscriptionOptions.map((opt) => ({
                      value: opt,
                      label: getSubscriptionLabel(opt),
                    }))}
                    value={form.subscriptionType || ""}
                    onChange={(e) =>
                      handleChange("subscriptionType", e.target.value)
                    }
                  />
                ) : (
                  <Input
                    value={form[key] || ""}
                    onChange={(e) => handleChange(key, e.target.value)}
                  />
                )
              ) : isUrl ? (
                form[key] ? (
                  <span>
                   <InlineLink
  href={form[key]}
  target="_blank"
  rel="noopener noreferrer"
>
  {translations[lang].restaurants.restaurantsRow.details.linkHere}
</InlineLink>
                  </span>
                ) : (
                  <span></span>
                )
              ) : key === "subscriptionType" ? (
                <span>{getSubscriptionLabel(form[key]) || "-"}</span>
              ) : (
                <span>{form[key] || "-"}</span>
              )}
            </div>
          );
        })}

        {!isEditing && (
          <div className="detail-row">
            <strong>
              {
                translations[lang].restaurants.restaurantsRow.details
                  .mainFieldLabels.email
              }
              :
            </strong>
            <span>{mainData.email || "-"}</span>
          </div>
        )}
      </div>

      {isEditing && (
        <>
          <h3>{translations[lang].restaurants.restaurantsRow.details.title2}</h3>

          <div className="details-grid">
            {mainFieldLabels.map((key) => (
              <div className="detail-row" key={key}>
                <strong>
                  {
                    translations[lang].restaurants.restaurantsRow.details
                      .mainFieldLabels[key]
                  }
                  :
                </strong>

                <Input
                  value={mainForm[key] || ""}
                  onChange={(e) =>
                    handleMainDataChanges(key, e.target.value)
                  }
                />
              </div>
            ))}
          </div>
        </>
      )}

      {can("restaurant.details.update", { restaurantId }) && (
        <div className="details-actions">
          {isEditing ? (
            <>
              <Button
                type="button"
                variant="primary"
                appearance="filled"
                fullWidth
                onClick={handleSave}
              >
                {translations[lang].restaurants.restaurantsRow.details.save}
              </Button>

              <Button
                type="button"
                variant="danger"
                appearance="soft"
                fullWidth
                onClick={handleCancel}
              >
                {translations[lang].restaurants.restaurantsRow.details.cancel}
              </Button>
            </>
          ) : (
            <Button
              type="button"
              variant="primary"
              appearance="soft"
              fullWidth
              onClick={() => setIsEditing(true)}
            >
              {translations[lang].restaurants.restaurantsRow.details.edit}
            </Button>
          )}
        </div>
      )}
    </>
  );
};
